import api from './api';

export interface LLMProviderConfig {
  provider: 'ollama' | 'bedrock';
  ollama_base_url: string;
  aws_region: string;
  has_aws_credentials: boolean;
  updated_at: string | null;
}

export interface LLMProviderUpdate {
  provider: 'ollama' | 'bedrock';
  ollama_base_url?: string;
  aws_access_key_id?: string;
  aws_secret_access_key?: string;
  aws_region?: string;
}

export interface ModelInfo {
  id: string;
  name: string;
  provider?: string;
}

export interface ModelsResponse {
  provider: string;
  models: ModelInfo[];
}

export const getProviderConfig = async (): Promise<LLMProviderConfig> => {
  const res = await api.get('/llm-provider');
  return res.data;
};

export const updateProviderConfig = async (updates: LLMProviderUpdate): Promise<LLMProviderConfig> => {
  const res = await api.put('/llm-provider', updates);
  return res.data;
};

export const getProviderModels = async (provider?: 'ollama' | 'bedrock'): Promise<ModelsResponse> => {
  const res = await api.get('/llm-provider/models', {
    params: provider ? { provider } : undefined,
  });
  return res.data;
};

export const testProviderConnection = async (
  provider?: string,
  model?: string,
): Promise<{ success: boolean; provider: string; model: string; response: string }> => {
  const res = await api.post('/llm-provider/test', { provider, model });
  return res.data;
};
